import ExpansionPreviewContainerWrapper from "./ExpansionPreviewContainerWrapper";
import ExpansionPreviewContainer from "./ExpansionPreviewContainer";
import CropRegionDropdown from "./CropRegionDropdown";
import A from './ActionCreators';
import useNavbar from './useNavbar';
import ExpansionLayoutEditor from "./ExpansionLayoutEditor";
import { flattenObject } from './utils';
import NewScaleToFit from './NewScaleToFit';
import G from './Getters';
import { useDispatch, useSelector, useStore } from 'react-redux';

import FigureImageExpansionContainer from './FigureImageExpansionContainer';
import { useFigurePanelId } from './FigurePanelIdProvider';
import { useState } from 'react';



const sceneOptions = [
  {_id:"preview",label:"Preview"},
  {_id:"layout",label:"Layout"},
]

export default function ExpansionPreview({
  onEvent,
  containerWidth=300,
  containerHeight,
  imageSetId,
  regionAssignments,
  setRegionAssignments,
  template,
  cellData,
  templateEvals,
  atnIdList,
  //focusedAnnotationId,
  //setFocusedAnnotationId,

  cellLocation,
  setImagePreviewContainer,
}){

  let channels = template.channels;

  //const [ view, navbar, setView ] = useNavbar({options:sceneOptions},"preview");

  const templateOverrides = flattenObject(template); 
  const [nodeRegionOverrides,setNodeRegionOverrides] = useState({});

  const figurePanelId = useFigurePanelId();
  const CONTAINER_WIDTH = containerWidth;

  const FULL_IMAGE_ATN_ID = `v_t=atn;geo=full;is=${imageSetId||templateEvals.find(x => x.imageSetId)?.imageSetId}`

  const store = useStore();
  const dispatch = useDispatch();

  const state = store.getState();

  let HOVER_COLOR = "#a6d3f7";


  let templateExp = G.getTemplateExpansion(
    null,template.compact
  );


  let value;

  if( !cellData || cellData.valueType !== "crop" ){

    let imageIdsByChannel = Object.fromEntries(Object.keys(channels).map((cc,ii) => ([cc,templateEvals[ii].imageId])));

    value = {
      type:"crop",
      regions:regionAssignments,
      template,
      imageIdsByChannel,

    }


  }else{

    let retrievedValue = G.getCellsValue(state,{figurePanelId,cells:[cellLocation]})[0];
    value = {
      ...retrievedValue,
      regions:regionAssignments,
    }
  }

  let imageIdsByChannel=Object.fromEntries(Object.keys(template.channels).map((channelId,ii) => ([channelId,templateEvals[ii].imageId])))

  const [ hoveredRegionId, setHoveredRegionId ] = useState();
  const [focusedRegionId,setFocusedRegionId] = useState("main");

  let atnTableList = [
    {type:"regionItem",
      action:"selectRegion",
      label:"Full image",_id:FULL_IMAGE_ATN_ID,title:<div style={{whiteSpace:'nowrap'}}>Full image</div>},
    ...atnIdList.map((atn,ii) => {
      let label = atn.label||("Crop " + (ii+1))
      return ({_id:atn._id,label,title:<div style={{whiteSpace:'nowrap'}}>{label}</div>,

        type:"regionItem",
      action:"selectRegion",

      })
    })
  ].filter(x => x)

  let previewValue = { ...value, imageIdsByChannel, templateOverrides }

  let expansionDimensions;
  if( Object.values(imageIdsByChannel).some(x => x) ){

    let expDimArgs = {

      value:previewValue,
      cellLocation,
      figurePanelId
    }

    expansionDimensions = G.getEvaluatedExpansionNodeDimensions(state,expDimArgs).root
  }
  let expDims = expansionDimensions;

  


  let expansionPreviewContainerArgs = {
      onEvent,
      template,

      regionList:atnTableList,
      focusedRegionId,
      setFocusedRegionId,

      hoveredRegionId,
      setHoveredRegionId,

      containerWidth,
      figurePanelId,
      cellLocation,
      value,
      templateOverrides,
      //expansionPreview,

      regionAssignments,
      setRegionAssignments,

      imageIdsByChannel,
    expDims,
    previewValue,


    }

 
  let expansionPreviewContainer = (
    <ExpansionPreviewContainer {...{
      onEvent,
      template,

      regionList:atnTableList,
      focusedRegionId,
      setFocusedRegionId,

      hoveredRegionId,
      setHoveredRegionId,

      containerWidth,
      figurePanelId,
      cellLocation,
      value,
      templateOverrides,
      //expansionPreview,

      regionAssignments,
      setRegionAssignments,

      imageIdsByChannel,


    }}>

      {expansionDimensions && <div style={{position:'fixed',top:0,left:0, background:'black',color:'cyan'}}>

        {JSON.stringify(expansionDimensions)}
      </div>}

      {false && <FigureImageExpansionContainer {...{
        figurePanelId,
        width:CONTAINER_WIDTH,
        cellLocation,
        value:previewValue
      }}/>}

      {(
    <NewScaleToFit dimensions={[
      containerWidth, // 2,
      containerHeight,// * 2
    ]} computeChildren={width => 
      <FigureImageExpansionContainer {...{
        figurePanelId,
        width:width??CONTAINER_WIDTH,
        cellLocation,
        value:previewValue
      }}/>
    } />
  )}
    </ExpansionPreviewContainer>
  )

  let { regions=templateExp.regions } = value;
  
  /*let layout = (
    <ExpansionLayoutEditor {...{
      expansionPreview,
        regionAssignments,
        setRegionAssignments,
        atnTableList,
        nodeRegionOverrides,
        setNodeRegionOverrides,

        regions,
    }}/>
  )*/

 
  let someImageHasBeenChosen = templateEvals.find(x => x.imageId)

  if( !someImageHasBeenChosen ){
    return (
      <>
      <h4 style={{textAlign:'center', 
        topMargin:20,
        }}>
        Assign images<br/>
      to preview template.
      </h4>
      </>
    )
  }


  const regionAssigner = false && (focusedRegionId ? (
    <div class="sg-row v-center">

      <div onClick={() => {
        setFocusedRegionId();
      }} class="fair-padding-right hoverable">X</div>

      <div class="flex-expand">
        <div><b>Choose region:</b></div>

        <div class="flex-expand">
          <CropRegionDropdown {...{
            atnTableList,

            value:regionAssignments[focusedRegionId],
            atnTableList,
            onEvent:(event) => {

              let _id = event.data;

              if( false && value.regions ){
                dispatch(A.setCellsValueProperties({
                  figurePanelId,
                  cells:[cellLocation],
                  properties:{
                    [`regions.${focusedRegionId}`]:_id,
                  }

                }))
              }
              setRegionAssignments({
                ...regionAssignments,
                [focusedRegionId]:_id,
              })
            }

            //value,onEvent:() => {}
          }}/>
        </div>
      </div>
    </div>) : ((
      <div>
      <div><b>Select items below</b></div>
      <div>to assign a region.</div>
      </div>

    ))
  )

  return (
    <div style={{
      minHeight:0,
      minWidth:0,
      //overflow:'auto',

      borderTop:'1px solid #ccc',
      //overflow:'hidden',
    }} class="flex-expand sg-col rel full-dim">

      <h4 style={{textAlign:'center'}} class="small-margin-top">Preview</h4>


        {true && <>
          {false && <div class="fair-margin"> {regionAssigner} </div>}

        <ExpansionPreviewContainerWrapper {...{
          someImageHasBeenChosen,
            view:"preview",
          //layout,
          expansionPreviewContainer,
          expansionPreviewContainerArgs,
        }}/>
        </>}



    </div>
  )
}

